export default __webpack_public_path__ + "static/media/LogoFull.3b7a6f28.svg";